export default () => {
    let trigger = document.querySelector('.js-load-more-modules');
    let items   = document.querySelectorAll('.js-module-card:nth-child(n + 4)');

    if (!trigger || !items)
        return;

    trigger.addEventListener('click', (e) => {
        e.preventDefault();

        items.forEach((item) => {
            item.classList.add('active');
        });

        trigger.remove();
    });
};